/**
 * Project Cost Budget detail print — print-engine composed pages + approval signers.
 */
import React, { useMemo } from 'react';
import { GenericPaginatedDocument } from '@/components/print/GenericPaginatedDocument';
import {
  buildProjectBudgetPrintDocument,
  summarizeProjectBudgetPrint,
  type BuildProjectBudgetPrintInput,
} from '@/print-engine/adapters/project-budget-adapter';

export type PrintableProjectBudgetRevisionProps = Omit<BuildProjectBudgetPrintInput, 'finalBlocks'> & {
  onClose?: () => void;
};

export const PrintableProjectBudgetRevision: React.FC<PrintableProjectBudgetRevisionProps> = (
  props
) => {
  const summary = useMemo(
    () =>
      summarizeProjectBudgetPrint({
        projectNumber: props.projectNumber,
        projectName: props.projectName,
        revision: props.revision,
        lines: props.lines,
      }),
    [props.projectNumber, props.projectName, props.revision, props.lines]
  );

  const model = useMemo(
    () =>
      buildProjectBudgetPrintDocument({
        ...props,
        finalBlocks: {
          totals: (
            <div style={{ textAlign: 'right', fontSize: 12, lineHeight: 1.5 }}>
              <div>
                Line count: <strong>{summary.lineCount}</strong>
              </div>
              <div style={{ fontSize: 14, marginTop: 4 }}>
                Budget total: <strong>{summary.totalLabel}</strong>
                {props.revision.currency ? ` ${props.revision.currency}` : ''}
              </div>
              <div style={{ marginTop: 4, color: '#444' }}>
                Status: <strong>{String(props.revision.status)}</strong>
                {' · '}
                Role: <strong>{String(props.revision.budget_role)}</strong>
              </div>
            </div>
          ),
        },
      }),
    [props, summary]
  );

  return <GenericPaginatedDocument model={model} onClose={props.onClose} />;
};
